(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tailoring-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var modal      = document.getElementById('tailoring-modal');
    if (!modal) return;

    var step1      = document.getElementById('tailoring-step-1');
    var step2      = document.getElementById('tailoring-step-2');
    var step3      = document.getElementById('tailoring-step-3');
    var step4      = document.getElementById('tailoring-step-4');
    var step5      = document.getElementById('tailoring-step-5');

    var totalEl    = document.getElementById('tailoring-total');
    var total2El   = document.getElementById('tailoring-total-2');
    var total3El   = document.getElementById('tailoring-total-3');
    var total4El   = document.getElementById('tailoring-total-4');
    var total5El   = document.getElementById('tailoring-total-5');

    var nextBtn             = document.getElementById('tailoring-next-btn');         /* Step 1 Next */
    var backBtn             = document.getElementById('tailoring-back-btn');         /* Back on blouse step 1 */
    var blouseTypeNext      = document.getElementById('tailoring-blouse-type-next'); /* Blouse type Next */
    var backBtn3            = document.getElementById('tailoring-back-btn-3');
    var neckSleeveNext      = document.getElementById('tailoring-neck-sleeve-next'); /* Neck/sleeve Next */
    var backBtn4            = document.getElementById('tailoring-back-btn-4');
    var measurementsNext    = document.getElementById('tailoring-measurements-next');/* Measurements Next */
    var backBtn5            = document.getElementById('tailoring-back-btn-5');
    var confirmBtn          = document.getElementById('tailoring-confirm-btn');

    /* ── helpers ── */
    /* data-price stores rupees (e.g. 735). Format as ₹735 without going through
       Shopify's money format (which expects paise and would output ₹7.35). */
    function formatMoney(rupees) {
      return '₹' + Math.round(rupees).toLocaleString('en-IN');
    }

    /* data-price: step-1 metaobject options + pad radio in step 3 + blouse type radio in step 2 */
    function getTotalRupees() {
      var total = 0;
      /* step-1 tailoring options (metaobject checkboxes/radios) */
      modal.querySelectorAll('.tailoring-modal__input:checked').forEach(function (inp) {
        total += parseFloat(inp.dataset.price || 0);
      });
      /* blouse type radio */
      var typeRadio = modal.querySelector('input[name="blouse_type"]:checked');
      if (typeRadio) total += parseFloat(typeRadio.dataset.price || 0);
      return total;
    }

    function updateTotal() {
      var rupees = getTotalRupees();
      var formatted = rupees > 0 ? formatMoney(rupees) : '₹0';
      if (totalEl)  totalEl.textContent  = formatted;
      if (total2El) total2El.textContent = formatted;
      if (total3El) total3El.textContent = formatted;
      if (total4El) total4El.textContent = formatted;
      if (total5El) total5El.textContent = formatted;
      document.dispatchEvent(new CustomEvent('tailoring:total-change', { detail: { rupees: rupees } }));
    }

    function isBlouseRequired() {
      var checked = modal.querySelectorAll('[data-blouse-option="true"]:checked');
      var required = false;
      checked.forEach(function (inp) {
        if (inp.value.toLowerCase().indexOf('not') === -1) required = true;
      });
      return required;
    }

    function isBlouseStitchingType() {
      var checked = modal.querySelector('input[name="tailoring_blouse_stitching"]:checked');
      if (!checked) return false;
      return checked.value.toLowerCase() === 'blouse';
    }

    function updateBlouseOnlyFields() {
      var hide = isBlouseStitchingType();
      modal.querySelectorAll('[data-blouse-only="true"]').forEach(function (el) {
        el.style.display = hide ? 'none' : '';
        var sel = el.querySelector('select');
        if (sel && hide) sel.value = '';
      });
    }

    function showOnly(stepEl) {
      [step1, step2, step3, step4, step5].forEach(function(s) {
        if (s) s.classList.toggle('tailoring-modal__step--hidden', s !== stepEl);
      });
      updateTotal();
    }

    /* ── add-unit mode state ── */
    var addUnitContext = null;

    /* ── open / close ── */
    function openModal() {
      addUnitContext = null;
      modal.removeAttribute('data-add-unit');
      var subtitle = modal.querySelector('.tailoring-modal__subtitle');
      if (subtitle) subtitle.remove();
      showOnly(step1);
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function openModalForAddUnit(context) {
      addUnitContext = context;
      modal.setAttribute('data-add-unit', '1');

      /* Reset all inputs then pre-select current options */
      modal.querySelectorAll('.tailoring-modal__input').forEach(function(inp) {
        inp.checked = false;
      });
      if (context.currentSelections) {
        Object.keys(context.currentSelections).forEach(function(groupLabel) {
          var values = context.currentSelections[groupLabel].split(', ');
          values.forEach(function(val) {
            modal.querySelectorAll('.tailoring-modal__input').forEach(function(inp) {
              if (inp.dataset.groupLabel === groupLabel && inp.value === val) inp.checked = true;
            });
          });
        });
      }

      /* Show subtitle */
      var existing = modal.querySelector('.tailoring-modal__subtitle');
      if (existing) existing.remove();
      var title = modal.querySelector('.tailoring-modal__title');
      if (title) {
        var sub = document.createElement('p');
        sub.className = 'tailoring-modal__subtitle';
        sub.textContent = 'Select stitching for the additional unit';
        title.insertAdjacentElement('afterend', sub);
      }

      showOnly(step1);
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      modal.removeAttribute('data-add-unit');
      addUnitContext = null;
      document.body.style.overflow = '';
      document.dispatchEvent(new CustomEvent('tailoring:total-change', { detail: { rupees: getTotalRupees() } }));
    }

    modal.querySelectorAll('.tailoring-modal__close').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });
    modal.querySelector('.tailoring-modal__backdrop').addEventListener('click', closeModal);

    /* ── Validation helpers ── */
    function showFieldError(el, msg) {
      el.classList.add('is-error');
      var field = el.closest('.tailoring-modal__field') || el.closest('.tailoring-modal__group');
      if (field && !field.querySelector('.tailoring-modal__field-error')) {
        var err = document.createElement('span');
        err.className = 'tailoring-modal__field-error';
        err.textContent = msg || 'This field is required';
        field.appendChild(err);
      }
    }
    function clearFieldError(el) {
      el.classList.remove('is-error');
      var field = el.closest('.tailoring-modal__field') || el.closest('.tailoring-modal__group');
      if (field) { var e = field.querySelector('.tailoring-modal__field-error'); if (e) e.remove(); }
    }
    modal.addEventListener('change', function (e) {
      if (e.target) clearFieldError(e.target);
    });

    /* Validate Step 1: only blouse stitching is required; fall/edges and inskirt are optional */
    var optionalGroupNames = ['tailoring_fall_edges', 'tailoring_inskirt'];
    function validateStep1() {
      var valid = true;
      modal.querySelectorAll('#tailoring-step-1 .tailoring-modal__group').forEach(function (group) {
        var input = group.querySelector('.tailoring-modal__input');
        if (!input) return;
        var groupName = input.name;
        if (optionalGroupNames.indexOf(groupName) !== -1) return;
        var checked = modal.querySelector('input[name="' + groupName + '"]:checked');
        if (!checked) {
          if (!group.querySelector('.tailoring-modal__field-error')) {
            var err = document.createElement('span');
            err.className = 'tailoring-modal__field-error';
            err.textContent = 'Please select an option';
            group.appendChild(err);
          }
          valid = false;
        }
      });
      return valid;
    }

    /* Validate Step 2: blouse type radio must be selected */
    function validateStep2() {
      var sel = modal.querySelector('input[name="blouse_type"]:checked');
      if (!sel) {
        var list = modal.querySelector('.tailoring-modal__blouse-type-list');
        if (list && !list.querySelector('.tailoring-modal__field-error')) {
          var err = document.createElement('span');
          err.className = 'tailoring-modal__field-error';
          err.textContent = 'Please select a blouse type';
          list.appendChild(err);
        }
        return false;
      }
      return true;
    }

    /* Validate Step 3: only validate fields that are rendered */
    function validateStep3() {
      var valid = true;
      var neck    = document.getElementById('blouse-neck');
      var sleeves = document.getElementById('blouse-sleeves');

      if (neck && neck.options.length > 1 && !neck.value) { showFieldError(neck, 'Please select neck type'); valid = false; }
      if (sleeves && sleeves.options.length > 1 && !sleeves.value) { showFieldError(sleeves, 'Please select sleeve type'); valid = false; }

      var padField = modal.querySelector('input[name="blouse_pad"]');
      if (padField && !modal.querySelector('input[name="blouse_pad"]:checked')) {
        showFieldError(padField, 'Please select pad option');
        valid = false;
      }
      return valid;
    }

    /* Validate Step 4: all measurement selects must be selected */
    function validateStep4() {
      var valid = true;
      var blouseOnlyIds = ['meas-height', 'meas-shoulder-pleat'];
      var measIds = [
        'meas-blouse-length', 'meas-chest', 'meas-waist',
        'meas-shoulder', 'meas-armhole', 'meas-sleeve-length',
        'meas-sleeve-around', 'meas-front-neck', 'meas-back-neck',
        'meas-height', 'meas-shoulder-pleat'
      ];
      var skipBlouseOnly = isBlouseStitchingType();
      measIds.forEach(function (id) {
        if (skipBlouseOnly && blouseOnlyIds.indexOf(id) !== -1) return;
        var el = document.getElementById(id);
        if (el && !el.value) { showFieldError(el, 'Required'); valid = false; }
      });
      return valid;
    }

    /* ── Step 1 Next: blouse stitching must be selected ── */
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (!validateStep1()) return;
        if (isBlouseRequired()) {
          showOnly(step2);
        } else {
          doAddToCart(nextBtn, 'Next');
        }
      });
    }

    /* ── Blouse step 1 back → step 1 ── */
    if (backBtn) {
      backBtn.addEventListener('click', function () { showOnly(step1); });
    }

    /* ── Blouse step 1 next → blouse step 2 ── */
    if (blouseTypeNext) {
      blouseTypeNext.addEventListener('click', function () {
        if (!validateStep2()) return;
        syncBlouseCards();
        showOnly(step3);
      });
    }

    /* ── Blouse step 2 back → blouse step 1 ── */
    if (backBtn3) {
      backBtn3.addEventListener('click', function () { showOnly(step2); });
    }

    /* ── Blouse step 2 next → blouse step 3 ── */
    if (neckSleeveNext) {
      neckSleeveNext.addEventListener('click', function () {
        if (!validateStep3()) return;
        updateBlouseOnlyFields();
        showOnly(step4);
      });
    }

    /* ── Blouse step 3 back → blouse step 2 ── */
    if (backBtn4) {
      backBtn4.addEventListener('click', function () { showOnly(step3); });
    }

    /* ── Blouse step 3 next → summary ── */
    if (measurementsNext) {
      measurementsNext.addEventListener('click', function () {
        if (!validateStep4()) return;
        buildSummary();
        showOnly(step5);
      });
    }

    /* ── Blouse step 4 (summary) back → blouse step 3 ── */
    if (backBtn5) {
      backBtn5.addEventListener('click', function () { updateBlouseOnlyFields(); showOnly(step4); });
    }

    /* ── Confirm: add to cart ── */
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        doAddToCart(confirmBtn, 'Add to Cart');
      });
    }

    /* ── Live total ── */
    modal.addEventListener('change', updateTotal);

    /* ── Visual cards (neck / sleeve) sync with select ── */
    modal.querySelectorAll('.tailoring-modal__visual-card').forEach(function (card) {
      card.addEventListener('click', function () {
        var selectId = card.dataset.select;
        var value    = card.dataset.value;
        var sel = document.getElementById(selectId);
        if (sel) sel.value = value;
        /* highlight siblings */
        modal.querySelectorAll('.tailoring-modal__visual-card[data-select="' + selectId + '"]').forEach(function (c) {
          c.classList.toggle('is-selected', c === card);
        });
        updateTotal();
      });
    });

    /* Sync select change → visual card highlight */
    ['blouse-neck', 'blouse-sleeves'].forEach(function (id) {
      var sel = document.getElementById(id);
      if (!sel) return;
      sel.addEventListener('change', function () {
        modal.querySelectorAll('.tailoring-modal__visual-card[data-select="' + id + '"]').forEach(function (c) {
          c.classList.toggle('is-selected', c.dataset.value === sel.value);
        });
        updateTotal();
      });
    });

    /* ── Deselect radio on second tap (radio or its label) ── */
    modal.querySelectorAll('.tailoring-modal__input, .tailoring-modal__blouse-type-radio').forEach(function (radio) {
      var wasChecked = false;

      function markState() {
        wasChecked = radio.checked;
      }
      function tryDeselect() {
        if (wasChecked) {
          radio.checked = false;
          wasChecked = false;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      /* Direct radio click */
      radio.addEventListener('mousedown', markState);
      radio.addEventListener('touchstart', markState, { passive: true });
      radio.addEventListener('click', tryDeselect);

      /* Label click — browser checks the radio AFTER label click fires,
         so read state on mousedown/touchstart, deselect in setTimeout */
      var label = radio.id ? modal.querySelector('label[for="' + radio.id + '"]') : null;
      if (label) {
        label.addEventListener('mousedown', markState);
        label.addEventListener('touchstart', markState, { passive: true });
        label.addEventListener('click', function () {
          if (wasChecked) {
            setTimeout(function () {
              radio.checked = false;
              wasChecked = false;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }, 0);
          }
        });
      }
    });

    /* ── Blouse type card highlight (driven by radio) ── */
    function syncBlouseCards() {
      var checked = modal.querySelector('input[name="blouse_type"]:checked');
      modal.querySelectorAll('.tailoring-modal__blouse-card').forEach(function (card) {
        var forId = card.getAttribute('for');
        card.classList.toggle('tailoring-modal__blouse-card--selected',
          checked != null && forId === checked.id);
      });
    }
    modal.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'blouse_type') { syncBlouseCards(); updateTotal(); }
    });
    /* clicking a card also triggers its radio via the label for= */

    /* ── Size chart auto-populate ── */
    var sizeChart = {
      '28 (XXS)': { 'meas-blouse-length': 15, 'meas-chest': 28, 'meas-waist': 26, 'meas-shoulder': 14,   'meas-armhole': 15, 'meas-sleeve-length': 6, 'meas-sleeve-around': 10, 'meas-front-neck': 7,  'meas-back-neck': 8  },
      '30 (XXS)': { 'meas-blouse-length': 15, 'meas-chest': 30, 'meas-waist': 28, 'meas-shoulder': 14.5, 'meas-armhole': 16, 'meas-sleeve-length': 6, 'meas-sleeve-around': 11, 'meas-front-neck': 7,  'meas-back-neck': 8  },
      '32 (XS)':  { 'meas-blouse-length': 15, 'meas-chest': 32, 'meas-waist': 30, 'meas-shoulder': 15,   'meas-armhole': 17, 'meas-sleeve-length': 6, 'meas-sleeve-around': 12, 'meas-front-neck': 7.5,'meas-back-neck': 9  },
      '34 (S)':   { 'meas-blouse-length': 15, 'meas-chest': 34, 'meas-waist': 32, 'meas-shoulder': 15.5, 'meas-armhole': 18, 'meas-sleeve-length': 7, 'meas-sleeve-around': 13, 'meas-front-neck': 7.5,'meas-back-neck': 9  },
      '36 (M)':   { 'meas-blouse-length': 15, 'meas-chest': 36, 'meas-waist': 34, 'meas-shoulder': 16,   'meas-armhole': 19, 'meas-sleeve-length': 7, 'meas-sleeve-around': 14, 'meas-front-neck': 8,  'meas-back-neck': 10 },
      '38 (L)':   { 'meas-blouse-length': 15, 'meas-chest': 38, 'meas-waist': 36, 'meas-shoulder': 16.5, 'meas-armhole': 20, 'meas-sleeve-length': 7, 'meas-sleeve-around': 15, 'meas-front-neck': 8.5,'meas-back-neck': 10 },
      '40 (XL)':  { 'meas-blouse-length': 15, 'meas-chest': 40, 'meas-waist': 38, 'meas-shoulder': 17,   'meas-armhole': 21, 'meas-sleeve-length': 8, 'meas-sleeve-around': 16, 'meas-front-neck': 9,  'meas-back-neck': 11 },
      '42 (2XL)': { 'meas-blouse-length': 15, 'meas-chest': 42, 'meas-waist': 40, 'meas-shoulder': 17.5, 'meas-armhole': 22, 'meas-sleeve-length': 8, 'meas-sleeve-around': 17, 'meas-front-neck': 9,  'meas-back-neck': 11 },
      '44 (3XL)': { 'meas-blouse-length': 15, 'meas-chest': 44, 'meas-waist': 42, 'meas-shoulder': 18,   'meas-armhole': 23, 'meas-sleeve-length': 8, 'meas-sleeve-around': 18, 'meas-front-neck': 10, 'meas-back-neck': 11 },
      '46 (4XL)': { 'meas-blouse-length': 15, 'meas-chest': 46, 'meas-waist': 44, 'meas-shoulder': 18.5, 'meas-armhole': 24, 'meas-sleeve-length': 8, 'meas-sleeve-around': 19, 'meas-front-neck': 10, 'meas-back-neck': 11 },
      '48 (5XL)': { 'meas-blouse-length': 15, 'meas-chest': 48, 'meas-waist': 46, 'meas-shoulder': 18.5, 'meas-armhole': 25, 'meas-sleeve-length': 8, 'meas-sleeve-around': 20, 'meas-front-neck': 10, 'meas-back-neck': 11 }
    };

    var sizeHidden = document.getElementById('meas-size');

    function applySize(sizeValue) {
      if (sizeHidden) sizeHidden.value = sizeValue;
      /* highlight chip */
      modal.querySelectorAll('.tailoring-modal__size-chip').forEach(function (chip) {
        chip.classList.toggle('is-selected', chip.dataset.size === sizeValue);
      });
      var measurements = sizeChart[sizeValue];
      if (!measurements) return;
      Object.keys(measurements).forEach(function (id) {
        var el = document.getElementById(id);
        if (!el) return;
        var val = measurements[id];
        var target = Math.round(val);
        for (var i = 0; i < el.options.length; i++) {
          if (parseInt(el.options[i].value, 10) === target) {
            el.selectedIndex = i;
            clearFieldError(el);
            break;
          }
        }
      });
    }

    modal.querySelectorAll('.tailoring-modal__size-chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        applySize(chip.dataset.size);
      });
    });

    /* ── Build summary ── */
    function buildSummary() {
      var container = document.getElementById('tailoring-summary');
      if (!container) return;

      var rows = collectSummaryRows();
      var html = '';
      rows.forEach(function (row) {
        if (!row.value) return;
        html += '<div class="tailoring-modal__summary-key">' + esc(row.label) + ':</div>' +
                '<div class="tailoring-modal__summary-val">' + esc(row.value) + '</div>';
      });
      container.innerHTML = html;
    }

    function esc(str) {
      return String(str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function collectSummaryRows() {
      var rows = [];

      /* Step-1 tailoring options */
      var groupMap = {};
      modal.querySelectorAll('.tailoring-modal__input:checked').forEach(function (inp) {
        var g = inp.dataset.groupLabel || 'Tailoring';
        if (!groupMap[g]) groupMap[g] = [];
        groupMap[g].push(inp.value);
      });
      Object.keys(groupMap).forEach(function (key) {
        rows.push({ label: key, value: groupMap[key].join(', ') });
      });

      /* Blouse type */
      var typeRadio = modal.querySelector('input[name="blouse_type"]:checked');
      if (typeRadio) rows.push({ label: typeRadio.dataset.groupLabel || 'Blouse Stitching Type', value: typeRadio.value });

      /* Neck / sleeve / pad */
      var neck    = document.getElementById('blouse-neck');
      var sleeves = document.getElementById('blouse-sleeves');
      var pad     = modal.querySelector('input[name="blouse_pad"]:checked');
      if (neck    && neck.value)    rows.push({ label: 'Neck',    value: neck.value });
      if (sleeves && sleeves.value) rows.push({ label: 'Sleeves', value: sleeves.value });
      if (pad)                      rows.push({ label: 'Pad',     value: pad.value });

      /* Measurements */
      var measMap = {
        'meas-size':          'Size',
        'meas-blouse-length': 'Blouse Length',
        'meas-chest':         'Chest / Bust',
        'meas-waist':         'Waist',
        'meas-shoulder':      'Shoulder',
        'meas-armhole':       'Armhole',
        'meas-sleeve-length': 'Sleeve Length',
        'meas-sleeve-around': 'Sleeve Round',
        'meas-front-neck':      'Front Neck',
        'meas-back-neck':       'Back Neck',
        'meas-height':          'Full Height',
        'meas-shoulder-pleat':  'Shoulder Pleat'
      };
      Object.keys(measMap).forEach(function (id) {
        var el = document.getElementById(id);
        if (el && el.value) rows.push({ label: measMap[id], value: el.value });
      });

      /* Notes */
      var notes = document.getElementById('blouse-notes');
      if (notes && notes.value.trim()) rows.push({ label: 'Additional Notes', value: notes.value.trim() });

      return rows;
    }

    /* ── Build line item properties (same data, flat object) ── */
    function buildProperties() {
      var props = {};
      collectSummaryRows().forEach(function (row) {
        if (row.value) props[row.label] = row.value;
      });
      var total = getTotalRupees();
      if (total > 0) props['Tailoring Extras'] = formatMoney(total);
      return props;
    }

    /* ── Add to cart ── */
    function doAddToCart(btn, originalLabel) {
      btn.textContent = '...';
      btn.disabled = true;

      /* ADD UNIT MODE */
      if (addUnitContext) {
        var ctx            = addUnitContext;
        var addonVariantId = parseInt(modal.dataset.addonVariantId, 10) || 0;
        var extraRupees    = Math.round(getTotalRupees());
        var props          = buildProperties();

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: ctx.variantId, quantity: 1, properties: props }] })
        })
        .then(function(r) { return r.json(); })
        .then(function(added) {
          if (!addonVariantId || extraRupees <= 0) return Promise.resolve();
          var mainKey = added.items && added.items[0] && added.items[0].key;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: addonVariantId, quantity: extraRupees, properties: { '_linked_item': String(mainKey) } }] })
          }).then(function(r) { return r.json(); });
        })
        .then(function() {
          closeModal();
          return fetch('/cart.js').then(function(r) { return r.json(); });
        })
        .then(function() {
          document.dispatchEvent(new CustomEvent('cart:open'));
        })
        .catch(function(err) {
          console.error('Tailoring ATC error', err);
          alert('Could not update cart. Please try again.');
        })
        .finally(function() {
          btn.disabled = false;
          btn.textContent = originalLabel;
        });
        return;
      }

      /* NORMAL MODE */
      var variantInput = document.getElementById('variant-id-input') ||
                         document.getElementById('variant-id-input-mobile');
      var variantId = variantInput ? parseInt(variantInput.value, 10) : null;
      if (!variantId) { btn.disabled = false; btn.textContent = originalLabel; return; }

      var addonVariantId = parseInt(modal.dataset.addonVariantId, 10) || 0;
      var extraRupees    = Math.round(getTotalRupees());
      var props          = buildProperties();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: props }] })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart error ' + r.status);
        return r.json();
      })
      .then(function (added) {
        if (!addonVariantId || extraRupees <= 0) return Promise.resolve();
        var mainKey = added.items && added.items[0] && added.items[0].key;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: addonVariantId, quantity: extraRupees, properties: { '_linked_item': String(mainKey || variantId) } }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('Cart error ' + r.status);
          return r.json();
        });
      })
      .then(function () {
        closeModal();
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.header-cart-count').forEach(function (b) {
          b.textContent = cart.item_count;
          b.style.display = '';
        });
        document.dispatchEvent(new CustomEvent('cart:open'));
      })
      .catch(function (err) {
        console.error('Tailoring ATC error', err);
        alert('Could not add to cart. Please try again.');
      })
      .finally(function () {
        btn.disabled = false;
        btn.textContent = originalLabel;
      });
    }

    /* ── Height info popup ── */
    var heightInfoOverlay = modal.querySelector('.js-height-info-overlay');
    var heightInfoClose   = modal.querySelector('.js-height-info-close');
    modal.querySelectorAll('[data-info-popup="height-info-popup"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (heightInfoOverlay) {
          heightInfoOverlay.classList.add('is-open');
          heightInfoOverlay.setAttribute('aria-hidden', 'false');
        }
      });
    });
    function closeHeightInfo() {
      if (heightInfoOverlay) {
        heightInfoOverlay.classList.remove('is-open');
        heightInfoOverlay.setAttribute('aria-hidden', 'true');
      }
    }
    if (heightInfoClose) heightInfoClose.addEventListener('click', closeHeightInfo);
    if (heightInfoOverlay) heightInfoOverlay.addEventListener('click', function (e) {
      if (e.target === heightInfoOverlay) closeHeightInfo();
    });

    /* ── Measurement guide lightbox ── */
    var guideOverlay = modal.querySelector('.js-measure-guide-overlay');
    var guideOpenBtn = modal.querySelector('.js-measure-guide-open');
    var guideCloseBtn = modal.querySelector('.js-measure-guide-close');
    if (guideOpenBtn && guideOverlay) {
      guideOpenBtn.addEventListener('click', function () {
        guideOverlay.classList.add('is-open');
        guideOverlay.setAttribute('aria-hidden', 'false');
      });
    }
    function closeGuide() {
      if (guideOverlay) {
        guideOverlay.classList.remove('is-open');
        guideOverlay.setAttribute('aria-hidden', 'true');
      }
    }
    if (guideCloseBtn) guideCloseBtn.addEventListener('click', closeGuide);
    if (guideOverlay) guideOverlay.addEventListener('click', function (e) {
      if (e.target === guideOverlay) closeGuide();
    });

    /* ── expose open to product page buttons ── */
    window.openTailoringModal = openModal;
    window.openTailoringModalForAddUnit = openModalForAddUnit;

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["try-with-ai-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    var gallery = document.getElementById('try-ai-gallery');
    if (!gallery) return;

    var BACKEND_URL  = (gallery.dataset.backendUrl || '').replace(/\/+$/, '');
    var PRODUCT_ID   = gallery.dataset.productId || '';
    var CUSTOMER_ID  = gallery.dataset.customerId || '';
    var LABEL        = gallery.dataset.i18nLabel || 'Your previous try-ons';
    var ALT          = gallery.dataset.i18nAlt || 'Previous AI try-on result';

    var labelEl = gallery.querySelector('.try-ai-gallery__label');
    var listEl  = document.getElementById('try-ai-gallery-list');

    labelEl.textContent = LABEL;

    function loadGallery() {
      if (!BACKEND_URL || !CUSTOMER_ID || !PRODUCT_ID) return;

      var url = BACKEND_URL + '/api/try-on/history?customerId=' + encodeURIComponent(CUSTOMER_ID) + '&productId=' + encodeURIComponent(PRODUCT_ID);

      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (res) {
          var items = res && res.success ? res.data : null;
          listEl.innerHTML = '';
          if (!items || !items.length) {
            gallery.hidden = true;
            return;
          }

          items.forEach(function (item) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'try-ai-gallery__item';
            var img = document.createElement('img');
            img.src = item.outputImageUrl;
            img.alt = ALT;
            img.loading = 'lazy';
            btn.appendChild(img);
            btn.addEventListener('click', function () {
              if (window.openTryWithAiModal) window.openTryWithAiModal(item.outputImageUrl);
            });
            listEl.appendChild(btn);
          });
          gallery.hidden = false;
        })
        .catch(function () {});
    }

    window.refreshTryAiGallery = loadGallery;
    loadGallery();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["try-with-ai-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var modal = document.getElementById('try-ai-modal');
    if (!modal) return;

    var BACKEND_URL             = (modal.dataset.backendUrl || '').replace(/\/+$/, '');
    var PRODUCT_IMAGE_URL       = modal.dataset.productImage || '';
    var PRODUCT_ID              = modal.dataset.productId || '';
    var PRODUCT_URL             = modal.dataset.productUrl || '';
    var PRODUCT_TITLE           = modal.dataset.productTitle || '';
    var PRIVACY_URL             = modal.dataset.privacyUrl || '/pages/privacy-policy';
    var CUSTOMER_ID             = modal.dataset.customerId || '';
    var CUSTOMER_NAME           = modal.dataset.customerName || '';
    var CUSTOMER_EMAIL          = modal.dataset.customerEmail || '';
    var POLL_INTERVAL_MS        = 2500;
    var POLL_TIMEOUT_MS         = 120000;
    var ESTIMATED_DURATION_MS   = 45000;
    var DEBUG = /[?&]try_ai_debug=1/.test(window.location.search) || window.localStorage.getItem('tryAiDebug') === '1';

    function debugLog() {
      if (!DEBUG) return;
      var args = Array.prototype.slice.call(arguments);
      args.unshift('[Try with AI]');
      console.log.apply(console, args);
    }

    var I18N = {
      uploadButton:  modal.dataset.i18nUploadButton  || 'Generate try-on',
      uploading:     modal.dataset.i18nUploading      || 'Uploading…',
      generating:    modal.dataset.i18nGenerating     || 'Generating your try-on…',
      uploadSuccess: modal.dataset.i18nUploadSuccess  || 'Here is your AI try-on!',
      uploadError:   modal.dataset.i18nUploadError    || 'Something went wrong. Please try again.',
      stepUploading: modal.dataset.i18nStepUploading  || 'Uploading your photo…',
      stepStyling:   modal.dataset.i18nStepStyling    || 'AI is styling your saree…',
      stepDraping:   modal.dataset.i18nStepDraping    || 'Draping fabric…',
      stepAdjusting: modal.dataset.i18nStepAdjusting  || 'Adjusting fit…',
      stepFinishing: modal.dataset.i18nStepFinishing  || 'Finishing details…',
      stepAlmostDone: modal.dataset.i18nStepAlmostDone || 'Almost done…',
      stepLovingIt:   modal.dataset.i18nStepLovingIt   || 'Hope you\'ll love the output…',
      addToCart:     modal.dataset.i18nAddToCart      || 'Add to bag',
      addedToCart:   modal.dataset.i18nAddedToCart    || 'Added!',
      download:      modal.dataset.i18nDownload       || 'Save',
      share:         modal.dataset.i18nShare          || 'Share',
      privacyRequired: modal.dataset.i18nPrivacyRequired || 'Please agree to the Privacy Policy to continue.',
      shareText:       modal.dataset.i18nShareText        || 'Check out my AI saree try-on from ' + PRODUCT_TITLE + '!',
      creditsRemaining: modal.dataset.i18nCreditsRemaining || '{{ remaining }} of {{ limit }} try-ons left today',
      creditsExhausted: modal.dataset.i18nCreditsExhausted || 'You\'ve used all your try-ons for today. Come back tomorrow!'
    };

    var dropzone           = document.getElementById('try-ai-dropzone');
    var fileInput          = document.getElementById('try-ai-file-input');
    var previewImg         = document.getElementById('try-ai-preview-img');
    var placeholder        = document.getElementById('try-ai-dropzone-placeholder');
    var statusEl           = document.getElementById('try-ai-status');
    var uploadBtn          = document.getElementById('try-ai-upload-btn');
    var creditsEl          = document.getElementById('try-ai-credits');
    var retryBtn           = document.getElementById('try-ai-retry-btn');
    var atcBtn             = document.getElementById('try-ai-atc-btn');
    var tailoringBtn       = document.getElementById('try-ai-tailoring-btn');
    var downloadBtn        = document.getElementById('try-ai-download-btn');
    var shareBtn           = document.getElementById('try-ai-share-btn');
    var shareMenu          = document.getElementById('try-ai-share-menu');
    var privacyCheckbox    = document.getElementById('try-ai-privacy-checkbox');
    var resultImg          = document.getElementById('try-ai-result-img');
    var originalImg        = document.getElementById('try-ai-original-img');
    var compareEl          = document.getElementById('try-ai-compare');
    var compareBeforeWrap  = document.getElementById('try-ai-compare-before-wrap');
    var compareHandle      = document.getElementById('try-ai-compare-handle');
    var loadingStepEl      = document.getElementById('try-ai-loading-step');
    var loadingImg         = document.getElementById('try-ai-loading-img');
    var progressFillEl     = document.getElementById('try-ai-progress-fill');
    var progressPctEl      = document.getElementById('try-ai-progress-pct');
    var modalPriceDisplay  = document.getElementById('try-ai-price-display');
    var modalStockAlert    = document.getElementById('try-ai-stock-alert');
    var modalOptionBtns    = modal.querySelectorAll('.try-ai-modal__option-btn');

    var stepUpload  = document.getElementById('try-ai-step-upload');
    var stepLoading = document.getElementById('try-ai-step-loading');
    var stepResult  = document.getElementById('try-ai-step-result');
    var footerUpload = document.getElementById('try-ai-footer-upload');
    var footerResult = document.getElementById('try-ai-footer-result');

    var selectedFile = null;
    var pollTimer = null;
    var loadingStepTimer = null;
    var progressTimer = null;
    var progressStartedAt = 0;

    function setStatus(text, type) {
      statusEl.textContent = text || '';
      statusEl.classList.remove('is-error', 'is-success');
      if (type) statusEl.classList.add('is-' + type);
    }

    function stopPolling() {
      if (pollTimer) {
        clearTimeout(pollTimer);
        pollTimer = null;
      }
    }

    function stopLoadingSteps() {
      if (loadingStepTimer) {
        clearInterval(loadingStepTimer);
        loadingStepTimer = null;
      }
    }

    function startLoadingSteps() {
      var steps = [
        I18N.stepUploading,
        I18N.stepStyling,
        I18N.stepDraping,
        I18N.stepAdjusting,
        I18N.stepLovingIt,
        I18N.stepFinishing,
        I18N.stepAlmostDone
      ];
      var i = 0;
      loadingStepEl.textContent = steps[0];
      stopLoadingSteps();
      loadingStepTimer = setInterval(function () {
        i = Math.min(i + 1, steps.length - 1);
        loadingStepEl.textContent = steps[i];
      }, 4000);
    }

    function stopProgress() {
      if (progressTimer) {
        clearInterval(progressTimer);
        progressTimer = null;
      }
    }

    function startProgress() {
      stopProgress();
      progressStartedAt = Date.now();
      progressFillEl.style.width = '0%';
      progressPctEl.textContent = '0%';
      progressTimer = setInterval(function () {
        var elapsed = Date.now() - progressStartedAt;
        var ratio = Math.min(elapsed / ESTIMATED_DURATION_MS, 0.95);
        var pct = Math.round(ratio * 100);
        progressFillEl.style.width = pct + '%';
        progressPctEl.textContent = pct + '%';
      }, 400);
    }

    function finishProgress() {
      stopProgress();
      progressFillEl.style.width = '100%';
      progressPctEl.textContent = '100%';
    }

    function showUploadStep() {
      stepUpload.hidden = false;
      stepLoading.hidden = true;
      stepResult.hidden = true;
      footerUpload.hidden = false;
      footerResult.hidden = true;
      modal.classList.remove('is-result-active');
      stopLoadingSteps();
      stopProgress();
    }

    function showLoadingStep(photoUrl) {
      stepUpload.hidden = true;
      stepLoading.hidden = false;
      stepResult.hidden = true;
      footerUpload.hidden = true;
      footerResult.hidden = true;
      modal.classList.remove('is-result-active');
      if (photoUrl) loadingImg.src = photoUrl;
      startLoadingSteps();
      startProgress();
    }

    function syncProductPanel() {
      var pagePriceDisplay = document.getElementById('product-price-display');
      if (pagePriceDisplay && modalPriceDisplay) {
        modalPriceDisplay.innerHTML = pagePriceDisplay.innerHTML;
      }
      var pageStockAlert = document.getElementById('stock-alert');
      if (pageStockAlert && modalStockAlert) {
        modalStockAlert.className = pageStockAlert.className;
        modalStockAlert.innerHTML = pageStockAlert.innerHTML;
        if (pageStockAlert.style.display === 'none') {
          modalStockAlert.style.display = 'none';
        } else {
          modalStockAlert.removeAttribute('style');
        }
      }
      var pageOptionBtns = document.querySelectorAll('.product-page .product-page__option-btn');
      modalOptionBtns.forEach(function (btn) {
        var idx = btn.getAttribute('data-option-index');
        var value = btn.getAttribute('data-value');
        var isSelected = false;
        pageOptionBtns.forEach(function (pageBtn) {
          if (pageBtn.getAttribute('data-option-index') === idx &&
              pageBtn.getAttribute('data-value') === value &&
              pageBtn.classList.contains('is-selected')) {
            isSelected = true;
          }
        });
        btn.classList.toggle('is-selected', isSelected);
      });
    }

    modalOptionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.getAttribute('data-option-index');
        var value = btn.getAttribute('data-value');
        var pageBtn = null;
        document.querySelectorAll('.product-page .product-page__option-btn').forEach(function (candidate) {
          if (candidate.getAttribute('data-option-index') === idx && candidate.getAttribute('data-value') === value) {
            pageBtn = candidate;
          }
        });
        if (pageBtn) pageBtn.click();
        syncProductPanel();
      });
    });

    function showResultStep(hasOriginal) {
      stepUpload.hidden = true;
      stepLoading.hidden = true;
      stepResult.hidden = false;
      footerUpload.hidden = true;
      footerResult.hidden = false;
      modal.classList.add('is-result-active');
      stopLoadingSteps();
      finishProgress();
      syncProductPanel();
      compareEl.classList.toggle('try-ai-modal__compare--no-original', !hasOriginal);
      if (hasOriginal) {
        requestAnimationFrame(function () { setCompareRatio(0.5); });
      }
    }

    function setCompareRatio(ratio) {
      ratio = Math.max(0, Math.min(1, ratio));
      var widthPx = compareEl.getBoundingClientRect().width;
      compareBeforeWrap.style.width = (ratio * 100) + '%';
      compareBeforeWrap.style.setProperty('--compare-width', widthPx + 'px');
      compareHandle.style.left = (ratio * 100) + '%';
    }

    function resetState() {
      stopPolling();
      selectedFile = null;
      fileInput.value = '';
      previewImg.src = '';
      previewImg.hidden = true;
      placeholder.hidden = false;
      resultImg.src = '';
      originalImg.src = '';
      loadingImg.src = '';
      compareEl.classList.remove('try-ai-modal__compare--no-original');
      creditsExhausted = false;
      uploadBtn.disabled = true;
      uploadBtn.textContent = I18N.uploadButton;
      uploadBtn.classList.remove('is-loading');
      atcBtn.textContent = I18N.addToCart;
      atcBtn.disabled = false;
      if (privacyCheckbox) privacyCheckbox.checked = false;
      closeShareMenu();
      setStatus('', null);
      showUploadStep();
    }

    function openModal(presetResultUrl) {
      resetState();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      fetchCredits();
      if (presetResultUrl) {
        resultImg.src = presetResultUrl;
        originalImg.src = '';
        showResultStep(false);
      }
    }

    function closeModal() {
      stopPolling();
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    modal.querySelectorAll('.try-ai-modal__close').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });
    modal.querySelector('.try-ai-modal__backdrop').addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    retryBtn.addEventListener('click', resetState);

    if (tailoringBtn) {
      tailoringBtn.addEventListener('click', function () {
        closeModal();
        if (window.openTailoringModal) window.openTailoringModal();
      });
    }

    function handleFile(file) {
      if (!file || file.type.indexOf('image/') !== 0) {
        selectedFile = null;
        uploadBtn.disabled = true;
        return;
      }
      selectedFile = file;
      previewImg.src = URL.createObjectURL(file);
      previewImg.hidden = false;
      placeholder.hidden = true;
      uploadBtn.disabled = creditsExhausted;
      setStatus('', null);
    }

    fileInput.addEventListener('change', function () {
      handleFile(fileInput.files && fileInput.files[0]);
    });

    /* ── Drag & drop (desktop) ── */
    ['dragenter', 'dragover'].forEach(function (evtName) {
      dropzone.addEventListener(evtName, function (e) {
        e.preventDefault();
        e.stopPropagation();
        dropzone.classList.add('is-dragover');
      });
    });
    ['dragleave', 'dragend'].forEach(function (evtName) {
      dropzone.addEventListener(evtName, function (e) {
        e.preventDefault();
        e.stopPropagation();
        dropzone.classList.remove('is-dragover');
      });
    });
    dropzone.addEventListener('drop', function (e) {
      e.preventDefault();
      e.stopPropagation();
      dropzone.classList.remove('is-dragover');
      var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (!file) return;
      fileInput.value = '';
      handleFile(file);
    });

    /* ── Before/after compare slider ── */
    var dragging = false;

    function ratioFromClientX(clientX) {
      var rect = compareEl.getBoundingClientRect();
      return (clientX - rect.left) / rect.width;
    }

    function onDragMove(clientX) {
      setCompareRatio(ratioFromClientX(clientX));
    }

    compareHandle.addEventListener('mousedown', function (e) {
      dragging = true;
      e.preventDefault();
    });
    compareHandle.addEventListener('touchstart', function () {
      dragging = true;
    }, { passive: true });

    document.addEventListener('mousemove', function (e) {
      if (dragging) onDragMove(e.clientX);
    });
    document.addEventListener('touchmove', function (e) {
      if (dragging && e.touches[0]) onDragMove(e.touches[0].clientX);
    }, { passive: true });

    document.addEventListener('mouseup', function () { dragging = false; });
    document.addEventListener('touchend', function () { dragging = false; });

    compareEl.addEventListener('click', function (e) {
      if (e.target === compareHandle || compareHandle.contains(e.target)) return;
      onDragMove(e.clientX);
    });

    window.addEventListener('resize', function () {
      if (!stepResult.hidden) {
        var current = compareBeforeWrap.getBoundingClientRect().width / compareEl.getBoundingClientRect().width;
        setCompareRatio(current);
      }
    });

    /* ── Result actions: download / share / add to cart ── */
    downloadBtn.addEventListener('click', function () {
      fetch(resultImg.src)
        .then(function (r) { return r.blob(); })
        .then(function (blob) {
          var blobUrl = URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = blobUrl;
          link.download = 'try-with-ai-result.jpg';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setTimeout(function () { URL.revokeObjectURL(blobUrl); }, 1000);
        })
        .catch(function () {
          var link = document.createElement('a');
          link.href = resultImg.src;
          link.download = 'try-with-ai-result.jpg';
          link.target = '_blank';
          link.rel = 'noopener';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    });

    function closeShareMenu() {
      shareMenu.hidden = true;
      shareBtn.setAttribute('aria-expanded', 'false');
    }

    function openShareMenu() {
      shareMenu.hidden = false;
      shareBtn.setAttribute('aria-expanded', 'true');
    }

    function canNativeShareFiles() {
      return !!(navigator.canShare && window.File);
    }

    function nativeShareImage() {
      return fetch(resultImg.src)
        .then(function (r) { return r.blob(); })
        .then(function (blob) {
          var file = new File([blob], 'try-with-ai-result.jpg', { type: blob.type || 'image/jpeg' });
          var shareUrl = PRODUCT_URL || window.location.href;
          var shareText = I18N.shareText + ' ' + shareUrl;
          var shareData = { files: [file], title: PRODUCT_TITLE, text: shareText };
          if (!navigator.canShare(shareData)) {
            return Promise.reject(new Error('cannot-share-files'));
          }
          return navigator.share(shareData);
        });
    }

    shareBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (canNativeShareFiles()) {
        nativeShareImage().catch(function (err) {
          if (err && err.name === 'AbortError') return;
          if (shareMenu.hidden) openShareMenu(); else closeShareMenu();
        });
        return;
      }
      if (shareMenu.hidden) openShareMenu(); else closeShareMenu();
    });

    document.addEventListener('click', function (e) {
      if (!shareMenu.hidden && !shareMenu.contains(e.target) && e.target !== shareBtn) {
        closeShareMenu();
      }
    });

    shareMenu.querySelectorAll('.try-ai-modal__share-option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var network = btn.dataset.share;
        var shareUrl = PRODUCT_URL || window.location.href;
        var text = I18N.shareText;

        switch (network) {
          case 'whatsapp':
            window.open('https://wa.me/?text=' + encodeURIComponent(text + ' ' + shareUrl), '_blank', 'noopener');
            break;
          case 'pinterest':
            window.open('https://pinterest.com/pin/create/button/?url=' + encodeURIComponent(shareUrl) + '&media=' + encodeURIComponent(resultImg.src) + '&description=' + encodeURIComponent(text), '_blank', 'noopener');
            break;
          case 'instagram':
          case 'snapchat':
            if (navigator.share) {
              navigator.share({ title: PRODUCT_TITLE, text: text, url: shareUrl }).catch(function () {});
            } else if (navigator.clipboard) {
              navigator.clipboard.writeText(text + ' ' + shareUrl).then(function () {
                setStatus(I18N.uploadSuccess, 'success');
              }).catch(function () {});
            }
            break;
          case 'copy':
            if (navigator.clipboard) {
              navigator.clipboard.writeText(text + ' ' + shareUrl).catch(function () {});
            }
            break;
        }
        closeShareMenu();
      });
    });

    atcBtn.addEventListener('click', function () {
      var variantInput = document.getElementById('variant-id-input');
      var variantId = variantInput && variantInput.value;
      if (!variantId) return;

      atcBtn.disabled = true;
      atcBtn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        atcBtn.textContent = I18N.addedToCart;
        closeModal();
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        debugLog('add to cart failed', err);
        atcBtn.disabled = false;
        atcBtn.classList.remove('is-loading');
      });
    });

    function readErrorBody(r) {
      return r.text().then(function (text) {
        var message = text;
        try {
          var json = JSON.parse(text);
          message = json.error || (json.errors && json.errors.join(', ')) || json.message || text;
        } catch (e) {}
        return message;
      }).catch(function () { return ''; });
    }

    function uploadCustomerPhoto(file) {
      debugLog('uploading photo to', BACKEND_URL + '/api/upload', file);
      return fetch(BACKEND_URL + '/api/upload', {
        method: 'POST',
        body: (function () {
          var formData = new FormData();
          formData.append('file', file);
          return formData;
        })()
      }).then(function (r) {
        if (!r.ok) {
          return readErrorBody(r).then(function (message) {
            debugLog('upload failed', r.status, message);
            throw new Error(message || ('Photo upload failed (' + r.status + ')'));
          });
        }
        return r.json();
      }).then(function (data) {
        debugLog('upload response', data);
        var url = data && data.data && data.data.url;
        if (!data || !data.success || !url) throw new Error('Backend did not return an uploaded photo URL');
        return url;
      });
    }

    var creditsLimit = null;
    var creditsExhausted = false;

    function renderCredits(remaining, limit) {
      if (typeof limit === 'number') creditsLimit = limit;
      if (!creditsEl) return;
      if (typeof remaining !== 'number' || typeof creditsLimit !== 'number') {
        creditsEl.hidden = true;
        return;
      }
      creditsEl.hidden = false;
      creditsExhausted = remaining <= 0;
      creditsEl.classList.toggle('try-ai-modal__credits--low', creditsExhausted);
      creditsEl.textContent = creditsExhausted
        ? I18N.creditsExhausted
        : I18N.creditsRemaining.replace('{{ remaining }}', remaining).replace('{{ limit }}', creditsLimit);
      if (creditsExhausted) uploadBtn.disabled = true;
    }

    function fetchCredits() {
      if (!BACKEND_URL || !CUSTOMER_ID) return;
      fetch(BACKEND_URL + '/api/try-on/credits?customerId=' + encodeURIComponent(CUSTOMER_ID))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var body = data && data.data;
          if (!body) return;
          renderCredits(body.remaining, body.limit);
        })
        .catch(function () {});
    }

    function createTryOnJob(userImageUrl) {
      var payload = {
        customerId: CUSTOMER_ID,
        productId: PRODUCT_ID,
        sareeImageUrl: PRODUCT_IMAGE_URL,
        userImageUrl: userImageUrl,
        privacyPolicyAccepted: true
      };
      if (CUSTOMER_NAME) payload.customerName = CUSTOMER_NAME;
      if (CUSTOMER_EMAIL) payload.customerEmail = CUSTOMER_EMAIL;
      if (PRODUCT_TITLE) payload.productName = PRODUCT_TITLE;
      debugLog('creating try-on job', BACKEND_URL + '/api/try-on', payload);
      return fetch(BACKEND_URL + '/api/try-on', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok) {
          return readErrorBody(r).then(function (message) {
            debugLog('try-on job creation failed', r.status, message);
            throw new Error(message || ('Failed to start AI try-on job (' + r.status + ')'));
          });
        }
        return r.json();
      }).then(function (data) {
        debugLog('try-on job created', data);
        var jobId = data && data.data && data.data.jobId;
        if (!data || !data.success || !jobId) throw new Error('Backend did not return a job id');
        if (typeof data.data.remainingCredits === 'number') {
          renderCredits(data.data.remainingCredits);
        }
        return jobId;
      });
    }

    function waitForTryOnJob(jobId) {
      var startedAt = Date.now();
      function poll() {
        return fetch(BACKEND_URL + '/api/try-on/' + jobId).then(function (r) {
          if (!r.ok) {
            return readErrorBody(r).then(function (message) {
              throw new Error(message || ('Failed to check AI try-on status (' + r.status + ')'));
            });
          }
          return r.json();
        }).then(function (res) {
          debugLog('poll job', jobId, res);
          var job = res && res.data;
          if (!job) throw new Error((res && res.error) || 'Failed to check AI try-on status');
          if (job.status === 'completed' && job.outputImageUrl) {
            return job.outputImageUrl;
          }
          if (job.status === 'failed') {
            throw new Error(job.errorMessage || 'AI try-on generation failed');
          }
          if (Date.now() - startedAt > POLL_TIMEOUT_MS) {
            throw new Error('Timed out waiting for AI try-on result');
          }
          return new Promise(function (resolve) {
            pollTimer = setTimeout(resolve, POLL_INTERVAL_MS);
          }).then(poll);
        });
      }
      return poll();
    }

    uploadBtn.addEventListener('click', function () {
      if (!selectedFile) return;
      if (privacyCheckbox && !privacyCheckbox.checked) {
        setStatus(I18N.privacyRequired, 'error');
        privacyCheckbox.focus();
        return;
      }
      if (!BACKEND_URL) {
        setStatus(I18N.uploadError, 'error');
        return;
      }
      var originalObjectUrl = previewImg.src;
      showLoadingStep(originalObjectUrl);
      setStatus('', null);

      uploadCustomerPhoto(selectedFile)
        .then(function (customerImageUrl) {
          return createTryOnJob(customerImageUrl);
        })
        .then(function (jobId) { return waitForTryOnJob(jobId); })
        .then(function (outputImageUrl) {
          originalImg.src = originalObjectUrl;
          resultImg.src = outputImageUrl;
          showResultStep(true);
          setStatus(I18N.uploadSuccess, 'success');
          if (window.refreshTryAiGallery) window.refreshTryAiGallery();
        })
        .catch(function (err) {
          console.error('Try with AI error:', err);
          var message = (err && err.message) ? err.message : I18N.uploadError;
          showUploadStep();
          setStatus(message, 'error');
          fetchCredits();
          uploadBtn.disabled = creditsExhausted;
          uploadBtn.textContent = I18N.uploadButton;
        });
    });

    window.openTryWithAiModal = openModal;

    window.tryAiDebug = {
      enable: function () { window.localStorage.setItem('tryAiDebug', '1'); location.reload(); },
      disable: function () { window.localStorage.removeItem('tryAiDebug'); location.reload(); },
      config: function () {
        return { backendUrl: BACKEND_URL, productImageUrl: PRODUCT_IMAGE_URL, productId: PRODUCT_ID };
      }
    };
  })();
  } catch(e) { console.error(e); }
})();

})();
